import { take, put, call, all, takeLatest, select } from 'redux-saga/effects';

import { cmsRequestPingStart, cmsRequestPingSuccess, cmsRequestPingFail } from '../../actions/cms/authen_cms';
import { cmsRequestLoginStart, cmsRequestLoginSuccess, cmsRequestLoginFail } from '../../actions/cms/authen_cms';
import { cmsRequestLogoutStart, cmsRequestLogoutSuccess, cmsRequestLogoutFail } from '../../actions/cms/authen_cms';

import requestManagement from '../../service/requestManagement';

const { method_POST, method_GET } = requestManagement;

import CONFIG from '@root/config/config.next';
const url = CONFIG.backendEndpoint;

export function* cmsRequestLogin({ payload }) {

  /*console.log('[sages] cmsRequestLoginStart :', { payload });*/

  const { username, password } = payload;
  const apiURL = `${url}/api/v1/auth/login`;

  try {

    const { data, code, msg, success, error } = yield method_POST({
      url: apiURL,
      data: { username, password }
    })

    /*console.log('[sages] cmsRequestLogin : POST : ', { data, code, msg, success, error, })*/

    if (error) {
      return yield put(cmsRequestLoginFail(error.data))
    }

    /*console.log('[saga] cmsRequestLogin setUserInfoSuccess : ', data);*/

    try {
      localStorage.setItem('cms_user_profile', JSON.stringify(data));
    } catch (error) { }

    yield put(cmsRequestLoginSuccess({ data, code, msg, success, error }))

  } catch (error) {

    console.error('[sages] cmsRequestLogin : [error] : ', error)

    yield put(cmsRequestLoginFail(error))
  }
}

export function* cmsRequestLogout({ payload }) {

  /*console.log('[sages] cmsRequestLogoutStart :', { payload });*/
  const cms_user_profile = JSON.parse(localStorage.getItem('cms_user_profile'));

  /*console.log('cms_user_profile : ', { cms_user_profile });*/

  const apiURL = `${url}/api/v1/auth/logout`;
  const { token } = payload;

  try {

    const data = yield method_GET({ url: apiURL, token: cms_user_profile?.token || token, param: { timestamp: moment().unix() } });

    /*console.log('[sages] cmsRequestLogout : POST : ', { data, code, msg, success, error, });*/

    yield put(cmsRequestLogoutSuccess({ data, code, msg, success, error }));

  } catch (error) {

    console.error('[sages] cmsRequestLogout : [error] : ', error);
    yield put(cmsRequestLogoutFail(error));

  }
}

export function* cmsRequestPing({ payload }) {

  /*console.log('[sages] cmsRequestPing : ', payload);*/

  const { redirect } = payload;
  const apiURL = `${url}/api/v1/auth/ping`;

  //====================================================================================================================

  try {

    const { data, error, code, success, msg } = yield method_GET({ url: apiURL });

    /*console.log("[sages] cmsRequestPing : ", { data, error, code, success, msg });*/

    if (code === 0) {

      /*console.log('[sages] cmsRequestPing : response : [data]', { data })*/

      try {
        // localStorage.setItem('user_profile', JSON.stringify(data));
      } catch (error) { }

      yield put(cmsRequestPingSuccess(data));
    }
    else
      yield put(cmsRequestPingFail(error?.data || {}));


  } catch (error) {

    console.error("[sages] cmsRequestPing Fail : ", error);
    yield put(cmsRequestPingFail(error));
  }

  //====================================================================================================================

}


export function* watchAuthCms() {

  /*console.log('[sages] watchAuthCms : ✅')*/

  yield all([takeLatest(cmsRequestLoginStart, cmsRequestLogin)])
  yield all([takeLatest(cmsRequestLogoutStart, cmsRequestLogout)])
  yield all([takeLatest(cmsRequestPingStart, cmsRequestPing)])
}
